module.exports = __webpack_public_path__ + "img/威胁分析系统-bg.99315cf0.jpg";